
import { list } from 'src/app/common/classes/request-builder';
import { FilteredValuesInterface, TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { FormRequestTypes } from 'src/app/common/components/reactive-form-builder/form-request';
import { Form, FormField, FormSection, FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { AnalisisModel } from 'src/app/models/analisis/analisis.model';
import { ClienteModel } from 'src/app/models/cliente.model';
import { AnalisisEnvironmentDefinition } from '../../environment-variables';
import { AnalisisListsDefinition } from './list-variables';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import moment from 'moment';

export class AnalisisFormDefinition {
  public formType!: FormType;

  public env: AnalisisEnvironmentDefinition = new AnalisisEnvironmentDefinition();

  public lists: AnalisisListsDefinition = new AnalisisListsDefinition();

  public model: AnalisisModel = {} as AnalisisModel;

  public formFieldsSection!: FormSection<object>;

  public formFieldsTitular!: FormSection<object>;

  public formFieldsResponsable!: FormSection<object>;

  public formFields!: Form<AnalisisModel>;

  public fieldNames: FormField<any>[] = [];

  public fieldLabels: string[] = [];

  public tareaComercial: TypeAheadInterface<string> = list(['...', null], 'Llamada', 'Email', 'Reunión', 'Demo', 'Presupuesto');

  public estadoPresupuestos: TypeAheadInterface<string> = list(['...', null], 'Enviado', 'Aplazado', 'Perdidos', 'Confirmado');

  public clientes: TypeAheadInterface<ClienteModel> | TypeAheadInterface<ClienteModel>[] = list();
    
  public shouldCreateNextAnalisis = true;

  public fechaSiguiente: string | undefined = undefined;

  public openDialog = false;

  constructor(
    type: FormRequestTypes,
    _model: Record<string, string>,
    table: (string[] | string[][])[] | null
  ) {
    this.formType = +type;

    const action = this.formType === FormType.CREATION ? 'Crear' : 'Actualizar';

    this.formFields = {
      name: 'analisis',
      header: action + ' Recordatorio de Análisis',
      type: this.formType,
      sections: this.getFormSections(),
      table: { title: '', showIndex: false, data: table?.[0], style: table?.[1] },
      uploadButton: {isEnabled: _model['estado'] === 'Realizada', label: 'Adjuntar Análisis'},
      signed: false
    };
  }


  public getGeneralFields(): FormField<any>[] {
    const generalFields: FormField<any>[] = [
      {
        name: 'id_cliente',
        vinculatedFields: undefined,
        label: this.env.clienteName,
        input: {
          type: this.env.applicationType === 'cropgest' ? InputType.MULTISELECT : InputType.DROPDOWN,
          isEditable: true,
          data: this.lists.clientes,
          dropdownConfiguration: {
            valuePrimaryKey: 'id',
            filter: (it: FilteredValuesInterface<ClienteModel>) => {
              if (this.env.clienteActual) {
                const isSelectedClient = (it.value || {}).id === this.env.clienteActual.id;
                return isSelectedClient;
              } else {
                return true;
              }
            },
          }
        },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.hasClients && this.env.isAdmin,
        },
        order: 1
      },
      {
        name: 'id_finca',
        vinculatedFields: undefined,
        label: this.env.fincaName,
        input: {
          type: InputType.DROPDOWN,
          isEditable: true,
          data: this.lists.fincas,
          dropdownConfiguration: {
            valuePrimaryKey: 'id',
            filter: (it: FilteredValuesInterface<FincasModel>) => {
              if (this.env.hasClients && this.env.isAdmin) {
                if (this.env.applicationType === 'cropgest') {
                  const listaIds: string[] = [];

                  /* Sí se intenta devolver la finca dentro del bucle no sucede nada, 
                                  por lo que se recoge en un listado los ids de los clientes para 
                                  hacer fuera la comprobación.
                              */
                  (this.lists.clientes.selected as ClienteModel[]).forEach((cliente: ClienteModel) => {
                    listaIds.push(cliente.id ?? '');
                  });

                  if (listaIds.includes(it.value?.id_cliente ?? '')) {
                    return true;
                  }
                } else {
                  return it.value?.id_cliente === ((this.lists.clientes.selected as ClienteModel) || ({} as ClienteModel)).id;
                }
              } else {
                return true;
              }
              return false;
            }
          }
        },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 2
      },
      {
        name: 'id_sector',
        vinculatedFields: undefined,
        label: this.env.appName === 'pyf' ? 'Paraje' : 'Sector',
        input: {
          type: InputType.DROPDOWN,
          isEditable: true,
          data: this.lists.sectores,
          dropdownConfiguration: {
            valuePrimaryKey: 'id',
            filter: (it: FilteredValuesInterface<SectorModel>) => {
              if (this.lists.fincas.selected == null) {
              } else if (this.lists.fincas.selected.id === it.value?.id_finca) {
                return true;
              }
              return false;
            },
          }
        },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showAnalisisSectorParcelasForm,
        },
        order: 3
      },
      {
        name: 'ids_parcelas',
        vinculatedFields: undefined,
        label: 'Parcelas',
        input: {
          type: InputType.MULTISELECT,
          isEditable: true,
          data: this.lists.lista_parcelas,
          dropdownConfiguration: {
            valuePrimaryKey: 'id',
            filter: (it: FilteredValuesInterface<ParcelasModel>) => {
              if (it.value?.activo?.toString() !== '1') {
                return false;
              }

              if (this.lists.sectores.selected) {
                return it.value.id_sector === (this.lists.sectores.selected || {}).id;
              } else {
                return it.value.id_finca === (this.lists.fincas.selected || {}).id;
              }
            },
          }
        },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showAnalisisSectorParcelasForm,
        },
        order: 4
      },
      {
        name: 'id_comunidad_regantes',
        vinculatedFields: undefined,
        label: 'Comunidad de Regantes',
        input: {
          type: InputType.DROPDOWN_SEARCH,
          isEditable: true,
          data: this.lists.comunidadesRegantes,
          dropdownConfiguration: {
            valuePrimaryKey: 'id',
          }
        },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 5,
        buttons: [
          {
            class: 'btn btn-success border rounded-circle shadow-sm p-0 d-flex align-items-center justify-content-center',
            style: `
              width: 26px;
              height: 26px;
              margin-left: 6px;
              font-size: .95rem;
              transform: translateY(-0.5rem);
            `,
            icon: 'fa fa-plus',
            label: '',
            tooltip: 'Añadir nuevo valor',
            tooltipPosition: 'top',
            function: () => this.openDialog = true
          }
        ],
      },
      {
        name: 'fecha',
        vinculatedFields: undefined,
        label: 'Fecha',
        input: { type: InputType.CALENDAR, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 6
      },
      {
        name: 'semana',
        vinculatedFields: undefined,
        label: 'Semana',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.applicationType === 'viverogest',
        },
        order: 7
      },
      {
        name: 'remesa',
        vinculatedFields: undefined,
        label: 'Remesa',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.applicationType === 'viverogest',
        },
        order: 8
      },
      {
        name: 'tipo_analisis',
        vinculatedFields: undefined,
        label: 'Tipo de análisis',
        input: {
          type: InputType.DROPDOWN,
          isEditable: true,
          data: this.lists.tiposAnalisis
        },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 9
      },
      {
        name: 'frecuencia',
        vinculatedFields: undefined,
        label: 'Frecuencia',
        input: {
          type: InputType.DROPDOWN,
          isEditable: this.env.appName !== 'lafast',
          data: this.lists.frecuencias,
          dropdownConfiguration: {
            swap: (it: FormField<object>) => {
              switch (this.env.appName) {
                case 'lafast':
                  it.input.data = this.lists.frecuenciasFast;
                  (it.input.data as any).selected = '1 año';
                  break;

                case 'armentia':
                  it.input.data = this.lists.frecuenciasArmentia;
                  break;

                case 'esparragosgranada':
                  it.input.data = this.lists.frecuenciasEsparragos;
                  break;

                default:
                  it.input.data = this.lists.frecuencias;
                  break;
              }

              if (this.lists.tiposAnalisis.selected.includes('Suelo')) {
                if (this.lists.tiposAnalisis.selected === 'Suelo - pH' || this.lists.tiposAnalisis.selected === 'Suelo - Conductividad') {
                  it.input.data = this.lists.frecuenciasEsparragos;
                  this.model.frecuencia = 'Semanal';
                  (it.input.data as any).selected = this.model.frecuencia;
                } else {
                  it.input.data = this.lists.frecuenciasSuelo;
                }
              } else if (this.lists.tiposAnalisis.selected === 'Foliar') {
                it.input.data = this.lists.frecuenciasFoliar;
              } else if (
                this.lists.tiposAnalisis.selected === 'Fruta - Naranja' ||
                this.lists.tiposAnalisis.selected === 'Fruta - Mandarina' ||
                this.lists.tiposAnalisis.selected === 'Fruta - Clementina' ||
                this.lists.tiposAnalisis.selected === 'Fruta - Satsuma'
              ) {
                it.input.data = this.lists.frecuenciasFruta;
              } else if (this.lists.tiposAnalisis.selected === 'Fruta - Fresón') {
                it.input.data = this.lists.frecuenciasFreson;
              } else if (this.lists.tiposAnalisis.selected === 'Residuos') {
                it.input.data = this.lists.frecuenciasResiduos;
              } else if (this.lists.tiposAnalisis.selected === 'Agua - Microbiológico') {
                it.input.data = this.lists.frecuenciasAguaM;
              } else if (this.lists.tiposAnalisis.selected === 'Agua - Químico') {
                it.input.data = this.lists.frecuenciasAguaQ;
              } else if (this.lists.tiposAnalisis.selected === 'Savia') {
                it.input.data = this.lists.frecuenciasSavia;
              }
            },
          }
        },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 10
      },
      {
        name: 'muestra',
        vinculatedFields: undefined,
        label: 'Muestra',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 11
      },
      {
        name: 'origen',
        vinculatedFields: undefined,
        label: 'Origen',
        input: { type: InputType.TEXT, isEditable: this.env.appName === 'fitogest' },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible:
            this.env.appName === 'almassora' ||
            this.env.appName === 'burriana' ||
            this.env.appName === 'lacooperativa' ||
            this.env.appName === 'onda',
        },
        order: 12
      },
      {
        name: 'objeto_analisis',
        vinculatedFields: undefined,
        label: 'Objeto del análisis',
        input: {
          type: InputType.DROPDOWN,
          isEditable: true,
          data: this.lists.lista_analisis
        },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 12
      },
      {
        name: 'analisis',
        vinculatedFields: undefined,
        label: 'Referencia Análisis',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showAnalisisNumeroAnalisis
        },
        order: 13
      },
      {
        name: 'boletin',
        vinculatedFields: undefined,
        label: 'Nº boletín',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showAnalisisBoletin,
        },
        order: 14
      },
      {
        name: 'laboratorio',
        vinculatedFields: undefined,
        label: 'Laboratorio',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showAnalisisBoletin || this.env.appName === 'avafitogest',
        },
        order: 15
      },
      {
        name: 'direccion_laboratorio',
        vinculatedFields: undefined,
        label: 'Dirección Laboratorio',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showAnalisisBoletin || this.env.appName === 'avafitogest',
        },
        order: 16
      },
      {
        name: 'sustancia_activa',
        vinculatedFields: undefined,
        label: 'Sustancia activa detectada',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showAnalisisBoletin || this.env.appName === 'avafitogest',
        },
        order: 17
      },
      {
        name: 'estado',
        vinculatedFields: undefined,
        label: 'Estado',
        input: {
          type: InputType.DROPDOWN,
          isEditable: true,
          data: this.lists.estados,
          defaultValue: 'Programada'
        },
        updateValue: (it) => {
          if ((it.input.data as any).selected === 'Realizada') {
            this.formFields.uploadButton = {isEnabled: true, label: 'Adjuntar Análisis'};
          }
        },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 18
      },
      {
        name: 'materia_activa',
        vinculatedFields: undefined,
        label: this.env.appName === 'laplana' ? 'Notas (cultivo)' : 'Notas',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 19
      },
      {
        name: 'volumen_kg',
        vinculatedFields: undefined,
        label: 'Volumen (kg)',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 20
      },
      {
        name: 'agua_m',
        vinculatedFields: undefined,
        label: 'Agua m³',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showAnalisisM3Agua,
        },
        order: 21
      },
      {
        name: 'mgrl',
        vinculatedFields: undefined,
        label: 'Nitratos (mg/l)',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showAnalisisMgrl || this.env.showCultivosBajoAguaFields,
        },
        order: 22
      },
    ];

    this.fieldNames = this.fieldNames.concat(generalFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(generalFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return generalFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }


  public getDatosSueloFields(): FormField<any>[] {
    const datosSueloFields: FormField<any>[] = [
      {
        name: 'ph_suelo',
        vinculatedFields: undefined,
        label: 'pH (suelo)',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 1
      },
      {
        name: 'mo_suelo',
        vinculatedFields: undefined,
        label: '% m.o. sobre m.s (0–30 cm)',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 2
      },
      {
        name: 'no3_suelo',
        vinculatedFields: undefined,
        label: '% NO3⁻ sobre m.s (0–30 cm)',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 3
      },
      {
        name: 'p2o5_suelo',
        vinculatedFields: undefined,
        label: '% P₂O₅ sobre m.s (0–30 cm)',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 4
      },
      {
        name: 'k2o_suelo',
        vinculatedFields: undefined,
        label: '% K₂O sobre m.s (0–30 cm)',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 5
      },
      {
        name: 'me_suelo',
        vinculatedFields: undefined,
        label: 'Me (análisis metales pesados – si aplica lodos tratados)',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 6
      }
    ];

    this.fieldNames = this.fieldNames.concat(datosSueloFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(datosSueloFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return datosSueloFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }


  public getResultadosAnalisisFields(isSectionVisible: boolean): FormField<any>[] {
    const resultadosAnalisisFields: FormField<any>[] = [
      {
        name: 'pH',
        vinculatedFields: undefined,
        label: 'pH',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 1
      },
      {
        name: 'conductividad',
        vinculatedFields: undefined,
        label: 'Conductividad',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 2
      },
      {
        name: 'sulfatos',
        vinculatedFields: undefined,
        label: 'Sulfatos',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 3
      },
      {
        name: 'nitratos',
        vinculatedFields: undefined,
        label: 'Nitratos',
        input: { type: InputType.TEXT, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 4
      },
      {
        name: 'valoracion',
        vinculatedFields: undefined,
        label: 'Valoración',
        input: { type: InputType.DROPDOWN, isEditable: true },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 5
      },
    ];

    this.fieldNames = this.fieldNames.concat(resultadosAnalisisFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(resultadosAnalisisFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return resultadosAnalisisFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
  
  public getFechaSiguienteFields(): FormField<any>[] {
    const fechaSiguienteFields: FormField<any>[] = [
      {
        name: 'fecha_siguiente_checked',
        vinculatedFields: undefined,
        label: 'Crear también el análisis siguiente (programado para el día ' + this.model.fechaSiguiente,
        input: { 
          type: InputType.SWITCH, 
          isEditable: true,
          defaultValue: this.shouldCreateNextAnalisis
        },
        turnVisible: (it) => {
          it.label = 'Crear también el análisis siguiente (programado para el día ' + this.model.fechaSiguiente

          it.conditions.isVisible = ((this.formType === FormType.CREATION || this.formType === FormType.DUPLICATION) && this.model.fechaSiguiente !== undefined);
        },
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: true,
          hasUndoEnabled: false,
          isVisible: false,
        },
        order: 1
      },
    ];

    this.fieldNames = this.fieldNames.concat(fechaSiguienteFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(fechaSiguienteFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return fechaSiguienteFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }


  public getHiddenFields(): FormField<any>[] {
    const hiddenFields: FormField<any>[] = [
      {
        name: 'id',
        vinculatedFields: undefined,
        label: '',
        input: {
          type: InputType.HIDDEN,
          defaultValue: this.model.id,
          isEditable: false
        },
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 1
      },
      {
        name: 'id_usuario',
        vinculatedFields: undefined,
        label: '',
        input: {
          isEditable: false,
          defaultValue: StorageManager.getClient()?.id_usuario_asignado ?? this.model.id_usuario ?? StorageManager.getUser().id,
          type: InputType.HIDDEN,
        },
        updateValue: () => StorageManager.getClient()?.id_usuario_asignado ?? this.model.id_usuario ?? StorageManager.getUser().id,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 2
      },
      {
        name: 'adjunto',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: false },
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 4
      },
      {
        name: 'fechaSiguiente',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: false },
        updateValue: () => {
          let period = 0;
          let timelapse: moment.unitOfTime.DurationConstructor = 'year';

          switch (this.model.frecuencia) {
            case 'Semanal':
              period = 7;
              timelapse = 'day';
              break;
            case 'Quincena':
              period = 15;
              timelapse = 'day';
              break;
            case '1 mes':
              period = 1;
              timelapse = 'month';
              break;
            case '2 meses':
              period = 2;
              timelapse = 'month';
              break;
            case '3 meses':
              period = 3;
              timelapse = 'month';
              break;
            case '4 meses':
              period = 4;
              timelapse = 'month';
              break;
            case '6 meses':
              period = 6;
              timelapse = 'month';
              break;
            case '1 año':
              period = 1;
              timelapse = 'year';
              break;
            case '2 años':
              period = 2;
              timelapse = 'year';
              break;
            case '3 años':
              period = 3;
              timelapse = 'year';
              break;
            case '4 años':
              period = 4;
              timelapse = 'year';
              break;
            case '5 años':
              period = 5;
              timelapse = 'year';
              break;

            default:
              break;
          }
          this.setNextDate(this.model.fecha ?? '', period, timelapse);
          return this.model.fechaSiguiente;
        },
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 5
      }
    ];

    this.fieldNames = this.fieldNames.concat(hiddenFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(hiddenFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return hiddenFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  private getFormSections(): FormSection<any>[] {
    const sections: FormSection<any>[] = [
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getGeneralFields(),
        order: 1
      },
      {
        name: 'Datos del Suelo',
        width: 12,
        isVisible: true,
        fields: this.getDatosSueloFields(),
        order: 2
      },
      {
        name: '',
        width: 12,
        isVisible: this.env.appName === 'viverospereira',
        fields: this.getResultadosAnalisisFields(this.env.appName === 'viverospereira'),
        order: 3
      },
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getFechaSiguienteFields(),
        order: 3
      },
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getHiddenFields(),
        order: 4
      },
    ];

    return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }


  public setNextDate(
    date: Date | string,
    period: number,
    timelapse: moment.unitOfTime.DurationConstructor
  ) {
    if (!date || !period || !timelapse) {
      this.model.fechaSiguiente = null;
      return;
    }
    if (typeof date === 'string') {
      date = moment(date, 'DD/MM/YYYY').toDate();
    }
    const auxDate = moment(date).add(period, timelapse);

    this.model.fechaSiguiente = auxDate.format('DD/MM/YYYY');
  }
}